import * as GLOBALS from '../globals';

/**
 * Initializes header menu mainly for mobile functions like the hamburger menu and dropdown menus
 */
export function InitHeaderMenu() {
	const headermenu = document.querySelector('.headermenu');
	const navigationList = $('.nav-list');
	const navigationItems = $('.nav-item-url');

	const windowScrollEvent = () => {
		UpdateActiveHeaderMenuItem($(navigationItems), $('.anchor-id'), headermenu.clientHeight);
	};

	window.addEventListener('load', windowScrollEvent);
	window.addEventListener('scroll', windowScrollEvent);
	window.addEventListener('resize', windowScrollEvent);

	InitMobileHamburger(navigationList, navigationItems);
	InitMobileDropdownMenu();
}

function UpdateActiveHeaderMenuItem(menuItems, pageAnchors, headerHeight) {
	const currentScrollPosition = window.pageYOffset + headerHeight;

	pageAnchors.each(function () {
		let targetPosition = $(this).offset().top;
		let id = $(this).attr('id');
		if (currentScrollPosition >= targetPosition - $(window).height() / 6) {
			menuItems.removeClass('active');
			$('a[data-nav-url][href$="' + id + '"]').addClass('active');
		}
	});
}

function InitMobileHamburger(navigationList, navigationItems) {
	const hamburgerButton = document.querySelector('.headermenu-hamburger-button');

	if(hamburgerButton === null)
		return;

	// Touch callback to animate the hamburger icon and show navigation menu
	hamburgerButton.addEventListener('click', () => {
		navigationList.slideToggle();
		$('.hamburger-menu').toggleClass('animate');
	});

	navigationItems.on('click', function (event) {
		if (!$(event.target).hasClass('nav-arrow-button') && window.innerWidth < GLOBALS.BREAKPOINT_LG)
			hamburgerButton.trigger('click');
	});
}

function InitMobileDropdownMenu() {
	// const mobileDropdownButtons = $('.nav-arrow-button');
	const mobileDropdownButtons = document.querySelectorAll('.nav-arrow-button');

	if(mobileDropdownButtons === null)
		return;

	// For each dropdown menu arrow hide the dropdown navigation and register a click callback which animates the
	// arrow and show the dropdown navigation menu
	mobileDropdownButtons.forEach((dropdownButton) => {
		dropdownButton.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();

			const target = $(event.target);
			const arrowButton = target.closest('.nav-item').find('.nav-arrow-button svg');

			arrowButton.toggleClass('rotate-180');
			arrowButton.closest('.nav-item').find('.nav-dropdown').slideToggle();
		});
	});

	if (window.innerWidth < GLOBALS.BREAKPOINT_LG) {
		$('.nav-dropdown-item-url.active')
			.parent('.nav-dropdown-item')
			.parent('.nav-dropdown')
			.siblings('.nav-item-url')
			.children('.nav-arrow-button')
			.trigger('click');
	}
}